import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IMaintenanceConfigResponse } from './maintenance-config.model';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private maintenanceEnabled = environment.maintenanceMode;
  private scheduledStart: Date | null = null;
  private scheduledEnd: Date | null = null;
  private customMessage: string | null = null;

  constructor(private httpClient: HttpClient) {}

  init(): Observable<void> {
    return this.httpClient
      .get<IMaintenanceConfigResponse>(`${environment.baseUrlApiMgt}/maintenance-config`)
      .pipe(
        timeout(environment.timeoutWebServiceCMS),
        map((response) => {
          const attrs = response?.data?.attributes;
          if (attrs) {
            this.maintenanceEnabled = attrs.maintenanceEnabled ?? environment.maintenanceMode;
            this.scheduledStart = attrs.scheduledStart ? new Date(attrs.scheduledStart) : null;
            this.scheduledEnd = attrs.scheduledEnd ? new Date(attrs.scheduledEnd) : null;
            this.customMessage = attrs.message ?? null;
          }
        }),
        catchError((error) => {
          console.warn('maintenance-config: fallback sur environment.maintenanceMode', error);
          return of(undefined);
        })
      );
  }

  isMaintenanceActive(): boolean {
    if (!this.maintenanceEnabled) return false;
    const now = new Date();
    if (this.scheduledStart && now < this.scheduledStart) return false;
    if (this.scheduledEnd && now > this.scheduledEnd) return false;
    return true;
  }

  getCustomMessage(): string | null {
    return this.customMessage;
  }
}
